import React from 'react';
import { AlertCircle } from 'lucide-react';
interface ErrorBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  onRetry?: () => void;
}
export function ErrorBottomSheet({
  isOpen,
  onClose,
  message,
  onRetry
}: ErrorBottomSheetProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-end justify-center pointer-events-none" data-id="element-47">
      <div className="absolute inset-0 bg-black/60 pointer-events-auto" onClick={onClose} data-id="element-48" />

      <div className="bg-slate-800 w-full max-w-md rounded-t-2xl p-6 pb-8 pointer-events-auto animate-in slide-in-from-bottom duration-300" data-id="element-49">
        <div className="flex justify-center mb-6" data-id="element-50">
          <div className="w-12 h-1 bg-slate-600 rounded-full" data-id="element-51" />
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-52">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-4 text-red-500" data-id="element-53">
            <AlertCircle size={32} data-id="element-54" />
          </div>

          <h2 className="text-xl font-bold text-white mb-2" data-id="element-55">Scan Failed</h2>
          <p className="text-slate-400 mb-8" data-id="element-56">{message}</p>

          <div className="flex space-x-3 w-full" data-id="element-57">
            <button onClick={onClose} className="flex-1 bg-slate-700 hover:bg-slate-600 text-white font-medium py-3 rounded-lg transition-colors" data-id="element-58">
              Cancel
            </button>
            {onRetry && <button onClick={onRetry} className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg transition-colors" data-id="element-59">
                Try Again
              </button>}
          </div>
        </div>
      </div>
    </div>;
}